import { h } from "preact";

import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

export default function YesNoDialog(props) {
	//console.log("YesNoDialog", props);
	const handleClose = () => {
		props.onClose();
	};
	if (!props.state.opened) {return;}
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					{props.state.params.title}
				</Typography>
			</DialogTitle>
			<DialogContent dividers>{props.state.params.body}</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" style="width: 100%">
					<Box>
						<Button onClick={handleClose}>Non</Button>
					</Box>
					<Box>
						<Button onClick={props.state.params.yes_action} variant="contained">
							Oui
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
